import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponse, handleError } = handlers;

function getAccounts(accountId) {
  const requestOptions = {
    method: 'GET',
    url: `/global?type=accounts&filterId=${accountId}`
  };

  return crFetch(requestOptions).then(handleResponse, handleError);
}

function getTimeZones() {
  const requestOptions = {
    method: 'GET',
    url: '/global?type=TimeZones'
  };

  return crFetch(requestOptions).then(handleResponse, handleError);
}

function getMachines(accountId) {
  const requestOptions = {
    method: 'GET',
    url: `/global?type=Machines&filterId=${accountId}`
  };

  return crFetch(requestOptions).then(handleResponse, handleError);
}

const globalService = {
  getAccounts,
  getTimeZones,
  getMachines,
};

export default globalService;
